import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import axios from "../../axios/axiosconf";
import { Link, useHistory, useLocation } from "react-router-dom";

function PlanAgendamientoForm() {
    const history = useHistory();
    const query = new URLSearchParams(useLocation().search);
    const planId = query.get("id");

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [listaPrecios, setListaPrecios] = useState([]);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [nombre, setNombre] = useState("");
    const [valor, setValor] = useState("");
    const [vencimientoDias, setVencimientoDias] = useState("");
    const [activo, setActivo] = useState(true);
    const [servicios, setServicios] = useState([{ lista_precios_id: "", sesiones: 1 }]);

    useEffect(() => {
        if (!localStorage.getItem("userdata")) {
            setLoggedIn(true);
            return;
        }
        const userdata = JSON.parse(localStorage.getItem("userdata"));
        Promise.all([
            axios.get("/get-client?uid=" + userdata.user_id),
            axios.get("/lista-precios?solo_activos=1"),
            planId ? axios.get("/plan-agendamiento", { params: { id: planId } }) : Promise.resolve(null),
        ])
            .then(([clientRes, preciosRes, planRes]) => {
                if (clientRes?.data) setClient(clientRes.data);
                setListaPrecios(preciosRes?.data || []);
                if (planRes?.data?.plan) {
                    const p = planRes.data.plan;
                    setNombre(p.nombre || "");
                    setValor(p.valor != null ? String(p.valor) : "");
                    setVencimientoDias(p.vencimiento_dias != null ? String(p.vencimiento_dias) : "");
                    setActivo(Number(p.activo) === 1);
                    const det = (planRes.data.detalle || []).map((d) => ({
                        lista_precios_id: String(d.lista_precios_id),
                        sesiones: Number(d.sesiones) || 1,
                    }));
                    setServicios(det.length ? det : [{ lista_precios_id: "", sesiones: 1 }]);
                }
                setLoggedIn(true);
            })
            .catch(() => setLoggedIn(true));
    }, [planId]);

    const updateServicio = (idx, field, value) => {
        setServicios((prev) => prev.map((row, i) => (i === idx ? { ...row, [field]: value } : row)));
    };

    const addServicio = () => setServicios((prev) => [...prev, { lista_precios_id: "", sesiones: 1 }]);
    const removeServicio = (idx) => setServicios((prev) => (prev.length <= 1 ? prev : prev.filter((_, i) => i !== idx)));

    const guardar = (e) => {
        e.preventDefault();
        setSaving(true);
        setError("");
        const payload = {
            id: planId || undefined,
            nombre,
            valor: Number(String(valor).replace(/[^\d.]/g, "")) || 0,
            vencimiento_dias: vencimientoDias === "" ? null : Number(vencimientoDias),
            activo: activo ? 1 : 0,
            servicios: servicios.map((s) => ({
                lista_precios_id: Number(s.lista_precios_id),
                sesiones: Number(s.sesiones) || 0,
            })),
        };
        const req = planId
            ? axios.put("/plan-agendamiento", payload)
            : axios.post("/plan-agendamiento", payload);
        req
            .then(() => history.push("/planes-agendamiento"))
            .catch((err) => {
                setError(err.response?.data?.message || "No se pudo guardar");
                setSaving(false);
            });
    };

    if (!loggedIn) return <Loading />;

    return (
        <div className="wrapper hold-transition plan-form-page" style={{ fontSize: "13px" }}>
            <Header client={client} />
            <Aside client={client} activelink="settings" />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <ol className="breadcrumb mb-2">
                            <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                            <li className="breadcrumb-item"><Link to="/parametros-agenda">Parámetros de agenda</Link></li>
                            <li className="breadcrumb-item"><Link to="/planes-agendamiento">Administrador de planes</Link></li>
                            <li className="breadcrumb-item active">{planId ? "Editar Plan" : "Crear Plan"}</li>
                        </ol>
                        <h1 className="m-0">{planId ? "Editar Plan" : "Crear Plan"}</h1>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <form onSubmit={guardar} className="card plan-form-card">
                            <div className="card-body">
                                {error && <div className="alert alert-danger py-2">{error}</div>}

                                <div className="plan-form-grid">
                                    <div className="plan-form-grid__top">
                                        <div className="plan-form-grid__nombre form-group mb-0">
                                            <label htmlFor="planNombre">Nombre *</label>
                                            <input
                                                id="planNombre"
                                                className="form-control"
                                                value={nombre}
                                                onChange={(e) => setNombre(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <div className="plan-form-grid__precio form-group mb-0">
                                            <label htmlFor="planPrecio">Precio</label>
                                            <input
                                                id="planPrecio"
                                                className="form-control"
                                                value={valor}
                                                onChange={(e) => setValor(e.target.value)}
                                            />
                                        
                                        </div>
                                        <div className="plan-form-grid__vencimiento form-group mb-0">
                                            <label htmlFor="planVencimiento">Vencimiento (días)</label>
                                            <input
                                                id="planVencimiento"
                                                type="number"
                                                min="0"
                                                className="form-control"
                                                value={vencimientoDias}
                                                onChange={(e) => setVencimientoDias(e.target.value)}
                                                placeholder="Opcional"
                                            />
                                        </div>
                                        <div className="plan-form-grid__activo form-group mb-0">
                                            <label className="d-block">&nbsp;</label>
                                            <div className="plan-form-switch-row">
                                                <label className="custom-switch custom-switch-sm mb-0" htmlFor="planActivo">
                                                    <input
                                                        type="checkbox"
                                                        id="planActivo"
                                                        checked={activo}
                                                        onChange={(e) => setActivo(e.target.checked)}
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label htmlFor="planActivo" className="mb-0 plan-form-switch-label">Activo</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="plan-form-grid__section-title">
                                        <h5 className="mb-1">Servicios del Plan</h5>
                                        <p className="text-muted small mb-0">Ítem de lista de precios + sesiones.</p>
                                    </div>

                                    <div className="plan-form-grid__col-label">Servicio</div>
                                    <div className="plan-form-grid__col-label plan-form-grid__col-label--center">Sesiones</div>
                                    <div className="plan-form-grid__col-label plan-form-grid__col-label--action" aria-hidden="true" />

                                    {servicios.map((row, idx) => (
                                        <React.Fragment key={`srv-${idx}`}>
                                            <div className="plan-form-grid__servicio">
                                                <select
                                                    className="form-control"
                                                    value={row.lista_precios_id}
                                                    onChange={(e) => updateServicio(idx, "lista_precios_id", e.target.value)}
                                                    required
                                                    aria-label="Servicio"
                                                >
                                                    <option value="">Seleccione…</option>
                                                    {listaPrecios.map((lp) => (
                                                        <option key={lp.id} value={lp.id}>
                                                            {lp.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="plan-form-grid__sesiones">
                                                <input
                                                    type="number"
                                                    min="1"
                                                    className="form-control"
                                                    value={row.sesiones}
                                                    onChange={(e) => updateServicio(idx, "sesiones", e.target.value)}
                                                    required
                                                    aria-label="Sesiones"
                                                />
                                            </div>
                                            <div className="plan-form-grid__accion">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm plan-form-icon-btn plan-form-icon-btn--danger"
                                                    title="Quitar servicio"
                                                    onClick={() => removeServicio(idx)}
                                                    disabled={servicios.length <= 1}
                                                >
                                                    <i className="fas fa-trash-alt" />
                                                </button>
                                            </div>
                                        </React.Fragment>
                                    ))}

                                    <div className="plan-form-grid__footer">
                                        <button
                                            type="button"
                                            className="btn btn-sm plan-form-icon-btn plan-form-icon-btn--add"
                                            title="Agregar servicio"
                                            onClick={addServicio}
                                        >
                                            <i className="fas fa-plus" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer text-right plan-form-card__footer">
                                <Link to="/planes-agendamiento" className="btn btn-outline-secondary mr-2">Cancelar</Link>
                                <button type="submit" className="btn btn-primary" disabled={saving}>
                                    {saving ? "Guardando…" : "Guardar"}
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default PlanAgendamientoForm;
